if (!customElements.get('product-metafield-tabs')) {
  customElements.define(
    'product-metafield-tabs',
    class ProductMetafieldTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
      }

      selectTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
        });
      }

      onKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          return;
        }

        event.preventDefault();

        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;

        this.tabs[nextIndex].focus();
        this.selectTab(this.tabs[nextIndex]);
      }
    }
  );
}
